import { ca } from "date-fns/locale";

const initialState = {
  companies: [],
  announcement: [],
  error: null,
  isLoding: false
};

const CompanyApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        isLoding: action.payload
      };

    case "GET_COMPANIES_SUCCESS":
      return {
        ...state,
        companies: action.payload,
        error: null
      };
    case "GET_COMPANIES_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_COMPANY_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_COMPANY_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_COMPANY_SUCCESS":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_COMPANY_FAILURE":
      return {
        ...state,

        error: action.payload.error
      };

    case "DELETE_COMPANY_SUCCESS":
      return {
        ...state,
        companies: state.companies.filter(
          (company) => company.id !== action.payload
        ),
        error: null
      };

    case "DELETE_COMPANY_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
    case "GET_ANNOUNCEMENT_SUCCESS":
      return {
        ...state,
        announcement: action.payload,
        error: null
      };
    case "GET_ANNOUNCEMENT_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_ANNOUNCEMENT_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_ANNOUNCEMENT_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
    case "UPDATE_ANNOUNCEMENT_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "UPDATE_ANNOUNCEMENT_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
    default:
      return state;
  }
};

export default CompanyApiReducer;
